/**
 * @description Contiene todas las rutas de la aplicación
 */

const homeBaseRoute = "/"
const homeRoutes = {
  index: `${homeBaseRoute}`,
}

const authBaseRoute = "/"
const authRoutes = {
  login: `${authBaseRoute}`,
  loginExplicit: "/login",
  logout: `${authBaseRoute}/logout`,
}

const administracionBaseRoute = "/administracion"
const usuariosRoutes = {
  index: `${administracionBaseRoute}/usuarios`,
  crear: `${administracionBaseRoute}/usuarios/formulario/crear`,
  actualizar: `${administracionBaseRoute}/usuarios/formulario/actualizar/:userId`,
}

const registroTiemposBaseRoute = "/registro-de-tiempos"
const registroTiemposRoutes = {
  index: `${registroTiemposBaseRoute}`,
}

const reporteGeneralBaseRoute = "/reporte-general"
const reporteGeneralRoutes = {
  index: `${reporteGeneralBaseRoute}`,
  horasSemana: `${reporteGeneralBaseRoute}/carga-semanal`,
  horasProyecto: `${reporteGeneralBaseRoute}/horas-proyecto`,
  horasEquipo: `${reporteGeneralBaseRoute}/horas-equipo`,
  horasCliente: `${reporteGeneralBaseRoute}/horas-cliente`,
  horasClienteRedirect: `${reporteGeneralBaseRoute}/horas-cliente/:clientCode/:startDate/:endDate`,
  consumosEquipo: `${reporteGeneralBaseRoute}/consumos-equipo`,
}

const reporteIndividualBaseRoute = "/reporte-individual"
const reporteIndividualRoutes = {
  index: `${reporteIndividualBaseRoute}`,
  redirect: `${reporteIndividualBaseRoute}/:teamMemberId/:startDate/:endDate/:period`,
}

const reporteClienteBaseRoute = "/reporte-cliente"
const reporteClienteRoutes = {
  index: `${reporteClienteBaseRoute}`,
  desarrollo: `${reporteClienteBaseRoute}/desarrollo`,
  consumo: `${reporteClienteBaseRoute}/consumo`,
  burnchart: `${reporteClienteBaseRoute}/burnchart`,
  historicoSprints: `${reporteClienteBaseRoute}/historico`,
  tareas: `${reporteClienteBaseRoute}/tareas`,
  descargaReporte: `${reporteClienteBaseRoute}/descarga-reporte`,
}

const clientesRoutes = {
  index: `${administracionBaseRoute}/clientes`,
  crear: `${administracionBaseRoute}/clientes/crear`,
  editar: `${administracionBaseRoute}/clientes/editar`,
  detalles: `${administracionBaseRoute}/clientes/editar`,
  crearProyecto: `${administracionBaseRoute}/clientes/proyecto/crear`,
  editarProyecto: `${administracionBaseRoute}/clientes/proyecto/editar`,
  presupuestoCliente: `${administracionBaseRoute}/clientes/presupuesto-cliente`,
}

const sandboxBaseRoute = "/sandbox"
const sandboxRoutes = {
  index: `${sandboxBaseRoute}`,
}

const configuracionBaseRoute = "/configuracion"
const configuracionRoutes = {
  index: `${configuracionBaseRoute}`,
}

const listaPendientesBaseRoute = "/lista-de-pendientes"
const listaPendientesRoutes = {
  index: `${listaPendientesBaseRoute}`,
}

const historialCambiosTareaBaseRoute = "/historial-tarea"
const historialCambiosTareaRoutes = {
  index: `${historialCambiosTareaBaseRoute}`,
  redirect: `${historialCambiosTareaBaseRoute}/:taskId`,
}

const dashboardBaseRoute = "/dashboard"
const dashboardRoutes = {
  index: `${dashboardBaseRoute}`,
}

const reporteOcupacionBaseRoute = "/reporte-ocupacion"
const reporteOcupacionRoutes = {
  index: `${reporteOcupacionBaseRoute}`,
  reporteComparativo: `${reporteOcupacionBaseRoute}/reporte-comparativo`,
  graficas: `${reporteOcupacionBaseRoute}/graficas`,
}

const changeLogBaseRoute = "/change-log"
const changeLogRoutes = {
  index: `${changeLogBaseRoute}`,
}

const integrantesBaseRoute = "/integrantes"
const integrantesRoutes = {
  index: `${integrantesBaseRoute}`,
  crear: `${integrantesBaseRoute}/crear`,
  editar: `${integrantesBaseRoute}/editar`,
}

const vacacionesBaseRoute = "/vacaciones"
const vacacionesRoutes = {
  index: `${vacacionesBaseRoute}/mis-vacaciones`,
  gestion: `${vacacionesBaseRoute}/gestion-vacaciones`,
  reporteVacaciones: `${vacacionesBaseRoute}/reporte-vacaciones`,
  historialVacaciones: `${vacacionesBaseRoute}/historial-vacaciones/:teamMemberId`,
  historialVacacionesMiembroEquipo: `${vacacionesBaseRoute}/mi-historial-vacaciones`,
}

const surveyRoutes = {
  survey: "/encuesta/:token",
}
const estimationsBaseRoute = "/estimaciones"
const estimationsRoutes = {
  agent: {
    chat: `${estimationsBaseRoute}/agent/chat`,
  },
}

export const AppRoutes = {
  home: homeRoutes,
  auth: authRoutes,
  usuarios: usuariosRoutes,
  registroTiempos: registroTiemposRoutes,
  reporteGeneral: reporteGeneralRoutes,
  reporteIndividual: reporteIndividualRoutes,
  reporteCliente: reporteClienteRoutes,
  clientes: clientesRoutes,
  sandbox: sandboxRoutes,
  configuracion: configuracionRoutes,
  listaPendientes: listaPendientesRoutes,
  historialCambios: historialCambiosTareaRoutes,
  dashboard: dashboardRoutes,
  reporteOcupacion: reporteOcupacionRoutes,
  changeLog: changeLogRoutes,
  integrantes: integrantesRoutes,
  vacaciones: vacacionesRoutes,
  surveys: surveyRoutes,
  estimations: estimationsRoutes,
}
